import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const Input = props => {
    const { type, className, value, onChange, onBlur, placeholder, checked, noClass, id, disabled, reference, list, pattern, onKeyPress, onInput, style, onKeyDown, onMouseOver, onWheel } = props;
    return (
        <input
            id={id ? id : ""}
            type={type ? type : 'text'}
            className={noClass ? "" : className ? className : 'form-control'}
            // value={value ? value : null}
            value={value ? value : null}
            checked={checked ? checked : ''}
            onChange={onChange ? onChange : null}
            onBlur={onBlur ? onBlur : null}
            placeholder={placeholder ? placeholder : 'Input'}
            disabled={disabled ? true : false}
            ref={reference ? reference : null}
            list={list ? list : null}
            pattern={pattern ? pattern : null}
            onKeyPress={onKeyPress ? onKeyPress : null}
            onKeyDown={onKeyDown ? onKeyDown : null}
            onMouseOver={onMouseOver ? onMouseOver : null}
            onWheel={onWheel ? onWheel : null}
            onInput={onInput ? onInput : null}
            style={style ? style : null}
        />
    );
}

export default Input;